// extracted by mini-css-extract-plugin
export var attribution = "_2f-4";
export var authorName = "_2f-5";
export var option = "_2f-g";
export var optionCard = "_2f-v";
export var optionContent = "_2f-w";
export var optionGrid = "_2f-12";
export var optionIcon = "_2f-y";
export var optionIconBox = "_2f-x";
export var optionLabel = "_2f-z";
export var optionList = "_2f-f";
export var optionPill = "_2f-13";
export var optionPillBadge = "_2f-16";
export var optionPillIcon = "_2f-14";
export var optionPillLabel = "_2f-15";
export var optionRadio = "_2f-10";
export var optionRadioInner = "_2f-11";
export var optionReveal = "_2f-i";
export var optionRevealDelay0 = "_2f-j";
export var optionRevealDelay1 = "_2f-k";
export var optionRevealDelay10 = "_2f-t";
export var optionRevealDelay11 = "_2f-u";
export var optionRevealDelay2 = "_2f-l";
export var optionRevealDelay3 = "_2f-m";
export var optionRevealDelay4 = "_2f-n";
export var optionRevealDelay5 = "_2f-o";
export var optionRevealDelay6 = "_2f-p";
export var optionRevealDelay7 = "_2f-q";
export var optionRevealDelay8 = "_2f-r";
export var optionRevealDelay9 = "_2f-s";
export var optionSelected = "_2f-h";
export var questionsBlock = "_2f-18";
export var quote = "_2f-3";
export var spacer = "_2f-b";
export var stepCenteredContent = "_2f-9";
export var stepInner = "_2f-6";
export var stepInnerFullWidth = "_2f-7";
export var stepInnerLockScroll = "_2f-8";
export var stepTransitionFrame = "_2f-a";
export var subtitle = "_2f-e";
export var testimonial = "_2f-2";
export var title = "_2f-c";
export var titleWithAccessory = "_2f-d";
export var trustedBy = "_2f-0";
export var trustedByLabel = "_2f-1";
export var welcomeBlock = "_2f-17";